import { LogsList } from "./views";

import { Route } from "react-router-dom";
export const LOG_ROUTES = [<Route path="/logs" element={<LogsList />} />];

export { LogsList } from "./views";
